import { Link } from "react-router-dom";

const AestheticianTaylor = () => {
  return (
    <div className="bg-secondary/5 p-8 rounded-lg">
      <Link to="/about#taylor" className="group">
        <div className="flex items-center gap-6 mb-6">
          <img
            src="/lovable-uploads/f76c72d0-52f4-479b-a891-4f0c6a891091.png"
            alt="Aesthetician Taylor"
            className="w-32 h-32 rounded-full object-cover transition-transform group-hover:scale-105"
          />
          <div>
            <h3 className="text-xl font-semibold">Aesthetician Taylor</h3>
            <p className="text-gray-600">Licensed Medical Aesthetician</p>
          </div>
        </div>
      </Link>
      <div className="prose prose-lg">
        <p className="text-gray-600">
          Taylor is our expert medical aesthetician with specialized training in advanced skincare treatments and facial therapies. Her comprehensive understanding of skin health and cutting-edge aesthetic procedures allows her to create personalized treatment plans that deliver exceptional results.
        </p>
        <p className="text-gray-600">
          With certification in medical-grade skincare and extensive experience in treatments such as chemical peels, microdermabrasion, and advanced facial therapies, Taylor is dedicated to helping clients achieve and maintain their skin health goals. Her attention to detail and commitment to continuing education ensures that our clients receive the most current and effective treatments available.
        </p>
      </div>
    </div>
  );
};

export default AestheticianTaylor;